module.exports = __webpack_public_path__ + "img/lg_ring_y_l_null_0@3x.938f57c7.png";